import React, { Component } from 'react';
import { Icon, Translate } from '$common';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import style from './header.scss';
import logoDark from '$shared/images/logo-dark.png';
import logoLight from '$shared/images/logo-light.png';
import logomuhimma from '$shared/images/muhimma-logo.png';
import Cookies from 'js-cookie';

const logos = { dark: logoLight, light: logoDark };

@CSSModules(style, { allowMultiple: true })
export default class Header extends Component {

  static defaultProps = {
    type: Cookies.get('mode') || 'dark'
  };

  state = {
    currentRouteName: window.location.pathname.split('/')
  };

  componentWillReceiveProps() {
    this.setState({ currentRouteName: window.location.pathname.split('/') });
  }

  get separator() {
    return (
      <div styleName="separator" />
    )
  }

  getRouteName(index) {
    const { currentRouteName } = this.state;
    return currentRouteName[currentRouteName.length - index] || null;
  }

  render() {
    const { agent, params } = this.props;
    const { currentRouteName } = this.state;

    return (
      <div id="not-printable">
        <div styleName={`root ${this.props.type} ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}>
          <Link to="/" styleName="logo">
            {
              process.twentify.indexOf(process.target[0]) !== -1 ?
                [
                  <img src={logos[this.props.type]} key={0}/>,
                  <span key={1}>Twentify</span>
                ]
              : <img src={logomuhimma} />
            }
          </Link>
          <ul styleName="navigation">
            {
              (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('project'))) ? 
                <li styleName={this.getRouteName(2) === "project" ? 'active' : ''}>
                  <Link to={params.id ? `/project/${params.id}` : `/project`}>
                    <Icon name="folder-open" />
                    <span>{Translate.get('project')}</span>
                  </Link>
                </li> : null
            }
            {
              (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('insights'))) ? 
                <li styleName={this.getRouteName(2) === "insights" || this.getRouteName(1) === "insights" ? 'active' : ''}>
                  <Link to={params.id ? `/project/${params.id}/insights` : `/project?path=insights`}>
                    <Icon name="area-chart" />
                    <span>{Translate.get('insights')}</span>
                  </Link>
                </li> : null
            }
            {
              (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('submissions'))) ? 
                <li styleName={this.getRouteName(1) === "submissions" ? 'active' : ''}>
                  <Link to={params.id ? `/project/${params.id}/submissions` : `/project?path=submissions`}>
                    <Icon name="table" />
                    <span>{Translate.get('submissions')}</span>
                  </Link>
                </li> : null
            }
          </ul>

          {this.separator}

          <ul styleName="navigation">
            {
              (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('gallery'))) ? 
                <li styleName={currentRouteName[1] === "gallery" ? 'active' : ''}>
                  <Link to="/gallery">
                    <Icon name="picture-o" />
                    <span>{Translate.get('gallery')}</span>
                  </Link>
                </li> : null
            }
            {
              (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('heat_map'))) ? 
                <li styleName={currentRouteName[1] === "heat-map" ? 'active' : ''}>
                  <Link to="/heat-map">
                    <Icon name="map-marker" />
                    <span>{Translate.get('heat_map')}</span>
                  </Link>
                </li> : null
            }
            <li styleName={currentRouteName[1] === "account" ? 'active' : ''}>
              <Link to="/account/edit">
                <Icon name="user" />
                <span>{Translate.get('account')}</span>
              </Link>
            </li>
          </ul>

          <Translate all="true"/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.js